import React, { ReactNode } from 'react';
import SupportIcon from '../../assets/auth/supporty-icon.svg';

// Define the type for the children prop
interface AuthLayoutProps {
  children: ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="relative min-h-screen bg-white">
      {/* Main content container */}
      {/* <div className="flex justify-center items-center h-full bg-gray-50"> */}
        {children}
      {/* </div> */}

      {/* Supporty Icon */}
      <img
        src={SupportIcon}
        alt="Supporty Icon"
        className="absolute bottom-4 right-4 w-24 h-40"
      />
    </div>
  );
};

export default AuthLayout;
